module.exports = __webpack_public_path__ + "static/shield@2x-4cf97abd3d06f706ed291b95bb114312.png";